import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 

import { ApplestoreBtnComponent } from './button.component'; 

@NgModule({
  declarations: [ApplestoreBtnComponent],
  exports: [ApplestoreBtnComponent],
  imports: [
    CommonModule, 
  ]
})
export class ApplestoreBtnModule {}
